<template>
	<div class="jobs-grid-wrapper">
		<v-data-table
			:headers="headers"
			:items="jobs"
			:rows-per-page-items="rowsPerPageItems"
			:pagination.sync="pagination"
			:total-items="pagination.totalItems"
			class="elevation-1"
			v-model="selected">

			<template slot="items" slot-scope="props">
				<tr :class="(props.item.is_archived) ? 'archived' : ''" :active="props.selected" @click.prevent.stop="handleRowClick(props.item)">
					<td :class="['viewed-indicator', {unread: props.item.viewed_status === false}]"/>
					<td class="no-smoosh">{{ getJobEnumItemValue('jobDepartments', props.item.department, 'abbreviation') }}</td>
					<td class="no-smoosh">{{ getJobEnumItemValue('jobTypes', props.item.type, 'name') }}</td>
					<td class="title">
						<a class="typography-text-btn" @click.stop="loadJobRequest(props.item.id, props.item.state)">{{ props.item.name }}
							<span v-if="props.item.priority || props.item.is_24_hour_rush" class="rush-item">{{getJobPriority(props.item)}}</span>
						</a>
					</td>
					<td class="no-smoosh date-col">{{ props.item.requestor | f__displayName }}</td>
					<td class="no-smoosh date-col">{{ getJobEnumItemValue('jobStatuses', props.item.status, 'name')}}</td>
					<td class="date-col">{{ displayData(props.item.state, props.item.date_submitted) | f__twoDigitFullDate }}</td>
					<!-- <td class="date-col">{{ displayData(props.item.state, props.item.date_premedia) | f__twoDigitFullDate }}</td> -->
					<!-- <td class="date-col">{{ displayData(props.item.state, props.item.date_first_comp) | f__twoDigitFullDate }}</td> -->
					<!-- <td class="date-col">{{ displayData(props.item.state, props.item.date_delivery) | f__twoDigitFullDate }}</td> -->
				</tr>
			</template>
            <template slot="no-data">
                <div class="view-global-loading" v-if="viewLoaded==false">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                </div>
                <div class="view-global-nodata" v-else>No Results Found</div>
            </template>
		</v-data-table>

        <excel-export-link
                type="requests"
        ></excel-export-link>
	</div>
</template>


<script>
	import { mapState, mapActions, mapGetters } from 'vuex'
    import Excel_Export_Link from '@/components/ui/_global/Excel_Export_Link.vue'
	import { VUEX_UI_SHOW_RIGHT_DRAWER } from '@/store/constants/ui'
	import {
		VUEX_JOB_GET_REQUEST,
		VUEX_JOB_CREATE_LOAD,
		VUEX_JOBS_SYNC_PAGINATION,
		} from '@/store/constants/jobs'

	export default {
		name: 'jobs-center-grid',

        components: {
            'excel-export-link' : Excel_Export_Link
        },

		data:() => ({
			items:[],
			selected:[],
			headers: [
				{ text: null, value: 'viewed', sortable: false, class: 'viewed-indicator'},
				{ text: 'Dept', value: 'department', sortable: true, class: 'no-smoosh' },
				{ text: 'Type', value: 'type', sortable: true, class: 'no-smoosh' },
				{ text: 'Name', value: 'name', sortable: true, width: '100%' },
				{ text: 'Requestor', value: 'requestor', sortable: true, class: 'no-smoosh' },
				{ text: 'Status', value: 'status', sortable: true, class: 'no-smoosh' },
				{ text: 'Submit', value: 'dateCreated', sortable: true, class: 'no-smoosh' },
				// { text: 'PRE', value: 'date_premedia', sortable: true, class: 'no-smoosh' },
				// { text: 'Comp', value: 'dateFirstComp', sortable: true, class: 'no-smoosh' },
				// { text: 'Deliver', value: 'dateDelivery', sortable: true, class: 'no-smoosh' },
			],
		}),

        beforeMount() {
            this.$store.dispatch('VUEX_JOBS_SET_APPROVED', { value: "false"})
        },

		computed: {
			...mapState({
				jobs: state => state.jobs.jobs,
                viewLoaded: state => state.jobs.jobsLoaded,
				rowsPerPageItems: state => state.properties.rowsPerPageItems,
				jobsPagination: state => state.jobs.pagination,

				jobCodes: state => state.properties.jobCodes,
				jobCreativeRounds: state => state.properties.jobCreativeRounds,
				jobDepartments: state => state.properties.jobDepartments,
				jobFlags: state => state.properties.jobFlags,
				jobPriorities: state => state.properties.jobPriorities,
				jobProgresses: state => state.properties.jobProgresses,
				jobProgressNotes: state => state.properties.jobProgressNotes,
				jobTypes: state => state.properties.jobTypes,

				watchedJobs: state => state.auth.currentUser.watched_jobs,
				flaggedJobs: state => state.auth.currentUser.flagged_jobs,
			}),

			pagination: {
					set(data) {
						this.applySorting(data)
					},
					get() {
						return this.jobsPagination
						}
				},

			...mapGetters({
				currentJobId: 'getJobId',
				currentUserHasPerm: 'currentUserHasPerm',
				getJobEnumItemValue: 'getJobEnumItemValue'
			}),

			getJobPriority() {
				return (item) => {
					if (item.is_24_hour_rush) return '24Hr'

					let priority = this.getJobEnumItemValue('jobPriorities', item.priority, 'name')
					return (priority !== 'Standard' && priority !== 'Extended') ? priority : ''
				}
			},

			displayData() {
				return (state, date) => {
					return state !== 'draft' ? date : null
				}
			}
		},

		methods: {
			...mapActions({
				loadJob: VUEX_JOB_GET_REQUEST,
				showRightDrawer: VUEX_UI_SHOW_RIGHT_DRAWER,
				loadDraft: VUEX_JOB_CREATE_LOAD,
				applySorting:VUEX_JOBS_SYNC_PAGINATION,
			}),

			loadJobRequest(id, state) {
				if (state !== "draft" && (
				    this.currentUserHasPerm(SILA_PERMISSION_JOBS_JOB_EXEC_APPROVE) ||
                    this.currentUserHasPerm(SILA_PERMISSION_JOBS_JOB_PRINT_APPROVE) ||
                    this.currentUserHasPerm(SILA_PERMISSION_JOBS_JOB_PACKAGE_APPROVE)
                )) {
					this.$router.push({ name:'job-overview', params:{ jobId: id } })
				} else {
                    this.loadDraft({ id })
				}
			},

			handleRowClick: async function(jobObj) {
				// TODO: Clear state, highlight, etc
				let jobId = jobObj.id

				this.selected = []
				this.selected.push(jobObj)

				if (jobId !== this.currentJobId) {
					await this.loadJob({ id: jobId, includeJobMeta: true })
				}

				if (jobObj !== "draft" && (
				    this.currentUserHasPerm(SILA_PERMISSION_JOBS_JOB_EXEC_APPROVE) ||
                    this.currentUserHasPerm(SILA_PERMISSION_JOBS_JOB_PRINT_APPROVE) ||
                    this.currentUserHasPerm(SILA_PERMISSION_JOBS_JOB_PACKAGE_APPROVE)
                )) {
					this.showRightDrawer()
				}
			},

			// TODO: Push this into the config vuex bit
			/*findEnumValue(needle, haystack) {
				let idx = haystack.findIndex(x => x.id === needle)
				if (idx < 0) return ''
				return haystack[idx]['name']
			},*/

			/*// TODO: This is not ideal; put on user obj in vuex
			isJobWatched(jobId) {
				let idx = this.watchedJobs.findIndex(x => x.job_id === jobId)
				return (idx > -1) ? true : false
			},

			// TODO: This is not ideal; put on user obj in vuex
			isJobFlagged(jobId) {
				let idx = this.flaggedJobs.findIndex(x => x.job_id === jobId)
				return (idx > -1) ? true : false
			},

			jobFlagColor(jobId) {
				let idx = this.flaggedJobs.findIndex(x => x.job_id === jobId)
				let color = 'grey'
				if (idx > -1) {
					let flag = this.jobFlags.findIndex(x => x.id === this.flaggedJobs[idx]['job_flag_id'])
					color = this.jobFlags[flag]['name'].toLowerCase()
				}
				return color
			}*/

		}
	}
</script>
